import request from '../utils/request.js'
import notice from '../utils/notice.js'
import { checkUnreadNotice } from '../utils/unread.js'

import Dexie from 'dexie';
const db_version = 1

const ws_url = "wss://ws.tripleuuunnniii.com:7230"
let webSocket = ''
let getting_chat_list = []
let pending_chat_detail_map = new Map()
let pending_chat_detail_timer = null
export let db = null

export const launchWebSocket = () => {
    if (!localStorage.getItem('token')) return
    if (!webSocket) {
        // console.log("先获取历史消息")
        getHistoryMessage()
            .catch(() => {
                return
            })
            .then(() => {
                return refreshChatReadStates()
            })
            .catch(() => {
                return
            })
            .then(() => {
                // console.log("然后链接")
                connectWebSocket()
            })
    } else {
        var message = {
            type: 'ping',
        }
        if (webSocket) {
            webSocket.send(JSON.stringify(message))
        }
    }
    setTimeout(() => {
        // console.log("每10秒检测一次")
        launchWebSocket()
    }, 10000);
}

export const closeWebsocket = () => {
    if (webSocket) webSocket.close()
    webSocket = ''
}

const connectWebSocket = () => {
    if (document.hidden) return
    if (webSocket) return

    webSocket = new WebSocket(ws_url)

    webSocket.onopen = () => {
        // console.log('WebSocket已连接')
        var message = {
            type: 'bind',
            token: localStorage.getItem('token')
        }
        webSocket.send(JSON.stringify(message))
    }

    webSocket.onmessage = (res) => {
        messageHandler(res.data)
    }

    webSocket.onerror = () => {
        //webSocket.close()
        // console.log('出现问题')
        // console.log(res)
    }

    webSocket.onclose = () => {
        // console.log('WebSocket已关闭')
        webSocket = null
    }
}

const messageHandler = (data) => {
    data = JSON.parse(data)
    switch (data.type) {
        case "bind":
            if (data.bind_result) {
                //   console.log("uid绑定成功")
            } else {
                //   console.log("uid绑定失败")
                webSocket.close()
                setTimeout(() => {
                    // console.log("重新连接")
                    connectWebSocket()
                }, 5000)
            }
            break
        case "message":
            var pm_detail = data.content
            // console.log(pm_detail)
            addPmToDb(pm_detail)
            const is_chat_detail = window.location.pathname == '/chat/' + pm_detail.chat_id
            if (is_chat_detail && !pm_detail.pm_is_from_me) {
                reportChatRead(pm_detail.chat_id, pm_detail.pm_id)
            }
            if (pm_detail.pm_is_from_me || window.location.pathname == '/chat' || is_chat_detail) return;
            notice({
                title: pm_detail.user_alias,
                content: pm_detail.pm_msg,
                user_avatar: pm_detail.user_avatar,
                url: '/chat/' + pm_detail.chat_id
            })
            break
        case "notice":
            var notice_detail = data.content
            var push_notice_data = {
                content: notice_detail.notice_msg,
                notice_id: notice_detail.notice_id
            }
            if (notice_detail.notice_data.uni_post_id) {
                if (window.location.pathname == '/post/' + notice_detail.notice_data.uni_post_id) return;
                Object.assign(push_notice_data, { url: '/post/' + notice_detail.notice_data.uni_post_id });
            }
            notice(push_notice_data)
            checkUnreadNotice()
            break
    }
}

const initDatabase = () => {
    const user_itsc = localStorage.getItem('user_itsc')
    const user_school_label = localStorage.getItem('user_school_label')
    db = new Dexie(user_itsc + '@' + user_school_label)
    db.version(db_version).stores({
        pm: "&pm_id, chat_id, pm_create_time",
        chat: "&chat_id, chat_update_time"
    })
}

const setUnreadPmCount = (count) => {
    localStorage.setItem('unread_pm', count)
    let event = new Event('updateUnreadPm')
    window.dispatchEvent(event)
}

export const refreshUnreadPmCount = () => {
    initDatabase()
    return db.chat.toArray()
        .then((chat_list) => {
            if (!chat_list || chat_list.length === 0) {
                setUnreadPmCount(0)
                return 0
            }
            const total = chat_list.reduce((sum, chat) => {
                const count = parseInt(chat.chat_unread_count, 10)
                return sum + (Number.isNaN(count) ? 0 : count)
            }, 0)
            setUnreadPmCount(total)
            return total
        })
}

const getHistoryMessage = () => {
    return new Promise(function (resolve, reject) {
        initDatabase()
        db.pm.orderBy("pm_id").reverse().limit(1).toArray()
            .then((res) => {
                var latset_pm_id_list = res
                var latset_pm_id = 0
                if (latset_pm_id_list[0]) {
                    latset_pm_id = latset_pm_id_list[0].pm_id
                }
                // console.log("latset_pm_id为" + latset_pm_id)
                request("/pm/message/history", {
                    pm_id: latset_pm_id
                }).then(res => {
                    if (!res) {
                        reject()
                        return
                    }
                    var pm_list = res.pm_list
                    pm_list.forEach(item => {
                        addPmToDb(item)
                    })
                    resolve()
                })
            })

    })
}

const normalizeId = (value) => {
    const parsed = parseInt(value, 10)
    return Number.isNaN(parsed) ? null : parsed
}

const countUnreadByReadPmId = (chat_id, read_pm_id) => {
    const chat_id_parsed = normalizeId(chat_id)
    const read_pm_id_parsed = normalizeId(read_pm_id)
    if (chat_id_parsed === null || read_pm_id_parsed === null) return Promise.resolve(null)
    return db.pm.where("chat_id").equals(chat_id_parsed)
        .and((pm) => !pm.pm_is_from_me && pm.pm_id > read_pm_id_parsed)
        .count()
}

export const applyChatReadState = (chat_detail, fallback_unread_count = 0) => {
    const read_pm_id_parsed = normalizeId(chat_detail.read_pm_id)
    return countUnreadByReadPmId(chat_detail.chat_id, read_pm_id_parsed)
        .then((unread_count) => {
            if (unread_count === null) {
                chat_detail.chat_unread_count = fallback_unread_count
                return chat_detail
            }
            chat_detail.read_pm_id = read_pm_id_parsed
            chat_detail.chat_unread_count = unread_count
            return chat_detail
        })
}

const reportChatRead = (chat_id, pm_id) => {
    const chat_id_parsed = normalizeId(chat_id)
    const pm_id_parsed = normalizeId(pm_id)
    if (chat_id_parsed === null || pm_id_parsed === null) return
    db.chat.update(chat_id_parsed, {
        chat_unread_count: 0,
        read_pm_id: pm_id_parsed
    }).then(() => {
        refreshUnreadPmCount()
    })
    request("/pm/chat/read", {
        chat_id: chat_id_parsed,
        pm_id: pm_id_parsed
    })
}

const queueChatDetailFetch = (chat_id, fallback_unread_count) => {
    const chat_id_parsed = normalizeId(chat_id)
    if (chat_id_parsed === null) return
    pending_chat_detail_map.set(chat_id_parsed, fallback_unread_count)
    if (pending_chat_detail_timer) return
    pending_chat_detail_timer = setTimeout(() => {
        const chat_id_list = Array.from(pending_chat_detail_map.keys())
        const fallback_map = new Map(pending_chat_detail_map)
        pending_chat_detail_map.clear()
        pending_chat_detail_timer = null
        if (chat_id_list.length === 0) return
        request("/pm/chat/getlist", {
            chat_id_list: JSON.stringify(chat_id_list)
        }, true, [400]).then((res) => {
            if (!res) return
            if (res.code == 400) return
            const chat_detail_list = res.chat_detail_list || []
            const refresh_tasks = chat_detail_list.map((chat_detail) => {
                const fallback_unread_count = fallback_map.has(normalizeId(chat_detail.chat_id))
                    ? fallback_map.get(normalizeId(chat_detail.chat_id))
                    : 0
                return applyChatReadState(chat_detail, fallback_unread_count)
                    .then((updated_chat_detail) => {
                        return db.chat.where("chat_id").equals(parseInt(chat_detail.chat_id)).limit(1).toArray()
                            .then((res) => {
                                var chat_list = res
                                if (!chat_list[0]) {
                                    db.chat.add(updated_chat_detail)
                                }
                            })
                    })
            })
            return Promise.all(refresh_tasks).then(() => {
                return refreshUnreadPmCount()
            })
        })
    }, 50)
}

const refreshChatReadStates = () => {
    initDatabase()
    return db.chat.toArray()
        .then((chat_list) => {
            if (!chat_list || chat_list.length === 0) {
                setUnreadPmCount(0)
                return
            }
            const chat_id_list = chat_list
                .map((chat) => normalizeId(chat.chat_id))
                .filter((chat_id) => chat_id !== null)
            if (chat_id_list.length === 0) return
            const chat_map = new Map(chat_list.map((chat) => [normalizeId(chat.chat_id), chat]))
            return request("/pm/chat/getlist", {
                chat_id_list: JSON.stringify(chat_id_list)
            }, true, [400]).then((res) => {
                if (!res) return
                if (res.code == 400) return
                const chat_detail_list = res.chat_detail_list || []
                const refresh_tasks = chat_detail_list.map((chat_detail) => {
                    const local_chat = chat_map.get(normalizeId(chat_detail.chat_id))
                    const fallback_unread_count = local_chat && typeof local_chat.chat_unread_count === 'number'
                        ? local_chat.chat_unread_count
                        : 0
                    const server_latest_msg = chat_detail.chat_latest_msg
                    const server_update_time = chat_detail.chat_update_time
                    return applyChatReadState(chat_detail, fallback_unread_count)
                        .then((updated_chat_detail) => {
                            if (typeof server_latest_msg !== 'undefined') {
                                updated_chat_detail.chat_latest_msg = server_latest_msg
                            } else if (local_chat && typeof local_chat.chat_latest_msg !== 'undefined') {
                                updated_chat_detail.chat_latest_msg = local_chat.chat_latest_msg
                            }
                            if (typeof server_update_time !== 'undefined') {
                                updated_chat_detail.chat_update_time = server_update_time
                            } else if (local_chat && typeof local_chat.chat_update_time !== 'undefined') {
                                updated_chat_detail.chat_update_time = local_chat.chat_update_time
                            }
                            return db.chat.put(updated_chat_detail)
                        })
                })
                return Promise.all(refresh_tasks).then(() => {
                    return refreshUnreadPmCount()
                })
            })
        })
}

const addPmToDb = (item) => {
    db.pm.where("pm_id").equals(parseInt(item.pm_id)).toArray()
        .then((res) => {
            var pm_list = res
            if (pm_list[0]) return
            db.pm.add(item)
            db.chat.where("chat_id").equals(parseInt(item.chat_id)).limit(1).toArray()
                .then((res) => {
                    var chat_list = res
                    if (!chat_list[0]) {
                        addChatToDb(item.chat_id, !item.pm_is_from_me)
                    } else {
                        var chat_detail = chat_list[0]
                        chat_detail.chat_latest_msg = item.pm_msg
                        chat_detail.chat_update_time = item.pm_create_time
                        if (!item.pm_is_from_me && window.location.pathname != '/chat/' + item.chat_id) {
                            chat_detail.chat_unread_count += 1
                        }
                        if (window.location.pathname == '/chat/' + item.chat_id) {
                            setTimeout(() => {
                                var chatBox = document.querySelector('.pm-list-container');
                                chatBox.scrollTop = chatBox.scrollHeight + 9999
                            }, 100);
                        }
                        db.chat.put(chat_detail).then(() => {
                            refreshUnreadPmCount()
                        })
                    }
                })
        })
}

const addChatToDb = (chat_id, is_unread) => {
    if (getting_chat_list.includes(chat_id)) return
    getting_chat_list.push(chat_id)
    const fallback_unread_count = is_unread ? 0 : 1
    queueChatDetailFetch(chat_id, fallback_unread_count)

}
